import { fetchWeeklyReportsInBatches } from '../../../api/weeklySearch';
import {
  buildWeeklyReportVisibilityRecoveryParams,
  mergeWeeklyReportRowsWithVisibilityRecovery,
} from '../../WeeklyReport/SearchArea/visibilityRecovery';

type OverwriteReportRow = {
  wr_id?: unknown;
  create_by_user_id?: unknown;
  createByUserId?: unknown;
};

/**
 * Overwrite Old の検索条件（下書きを含む）を保ったまま、公開先から外れた
 * 本人の週報を回復する。他ユーザーの検索結果は既存の公開判定を維持する。
 */
export const fetchOverwriteReportsWithOwnerAccess = async <T extends OverwriteReportRow>(args: {
  params: URLSearchParams;
  authenticatedUserId: unknown;
  canAccess: (row: T) => boolean;
}): Promise<T[]> => {
  const canRecoverOwner =
    typeof args.authenticatedUserId === 'string' &&
    args.authenticatedUserId.trim().length > 0 &&
    (args.params.has('USER_DEP') || args.params.has('USER_TEAM_ID'));

  const [scopedRows, recoveryRows] = await Promise.all([
    fetchWeeklyReportsInBatches<T>(args.params),
    canRecoverOwner
      ? fetchWeeklyReportsInBatches<T>(buildWeeklyReportVisibilityRecoveryParams(args.params))
          .catch((error) => {
            console.warn('overwrite owner search recovery failed', error);
            return [];
          })
      : Promise.resolve([]),
  ]);

  return mergeWeeklyReportRowsWithVisibilityRecovery({
    scopedRows,
    recoveryRows,
    authenticatedUserId: args.authenticatedUserId,
    decideVisibility: (row) => ({
      allowed: args.canAccess(row),
      // この回復検索で追加するのは本人の週報のみ。
      configured: false,
    }),
  });
};
